"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failed = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var styles_1 = require("../../../styles");
var IoIosWarning_1 = require("@react-icons/all-files/io/IoIosWarning");
var Components_1 = require("../Components");
var hooks_1 = require("../hooks");
var react_1 = require("react");
var utils_1 = require("../../../utils");
var hooks_2 = require("../../../hooks");
function Failed(_a) {
    var _b;
    var error = _a.error;
    var nativeBalance = (0, react_1.useMemo)(function () { return (0, utils_1.isNativeBalanceError)(error); }, [error]);
    var nativeToken = (_b = (0, hooks_2.useNetwork)()) === null || _b === void 0 ? void 0 : _b.native.symbol;
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-create-order-failed" }, { children: [(0, jsx_runtime_1.jsx)(Logo, {}), (0, jsx_runtime_1.jsx)(Title, {}), nativeBalance && (0, jsx_runtime_1.jsxs)(styles_1.StyledText, __assign({ className: "twap-order-modal-failed-subtitle" }, { children: ["Insufficient ", nativeToken, " balance"] })), (0, jsx_runtime_1.jsx)(Components_1.SmallTokens, {}), (0, jsx_runtime_1.jsx)(Components_1.BottomContent, { text: "Learn more", href: "/" })] })));
}
exports.Failed = Failed;
var Title = function () {
    var type = (0, hooks_1.useOrderType)();
    return (0, jsx_runtime_1.jsx)(StyledTitle, __assign({ className: "twap-order-modal-failed-title" }, { children: "".concat(type, " order failed") }));
};
var StyledTitle = (0, styled_components_1.styled)(styles_1.StyledText)({
    fontSize: 24,
});
var Logo = function () {
    return ((0, jsx_runtime_1.jsx)(StyledLogo, __assign({ className: "twap-order-modal-failed-logo" }, { children: (0, jsx_runtime_1.jsx)(IoIosWarning_1.IoIosWarning, {}) })));
};
var StyledLogo = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    background: "rgba(255, 255, 255, 0.07)",
    width: 48,
    height: 48,
    borderRadius: 12,
    svg: {
        fill: "rgb(155, 155, 155)",
        width: 24,
        height: 24,
    },
});
var StyledContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    alignItems: "center",
    ".twap-order-modal-failed-subtitle": {
        fontSize: 15,
        fontWeight: 500,
    },
});
